// Unpublished Work © 2020-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import {Switch, FormControlLabel} from '@deere/isg.component-library';
import {joinClassNames} from 'Utils/html-utils';

function getSwitchLabel(checked, onLabel, offLabel) {
    if (onLabel && !offLabel) {
        return onLabel;
    }

    if (!onLabel && offLabel) {
        return offLabel;
    }

    return checked ? onLabel : offLabel;
}

function SwitchInput(props) {
    const {
        checked = false,
        className,
        name,
        offLabel,
        onChange,
        onLabel,
        translations,
        disabled = false
    } = props;

    return (
        <FormControlLabel
            className={joinClassNames('switch-label', className)}
            control={<Switch
                checked={checked}
                className='switch-input'
                disabled={disabled}
                onChange={() => onChange(name, !checked)}
                translations={translations}
            />}
            label={getSwitchLabel(checked, onLabel, offLabel)}
        />
    );
}

SwitchInput.propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
    offLabel: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onLabel: PropTypes.string,
    translations: PropTypes.translations
};

export default SwitchInput;
